import { ImageService } from "@DavisDigital/davisdigitalfrontend.module";
import * as IDavis from '@DavisDigital/interfaces';

class ImageCollectionCopyModalController {
    
    public isLoading = false;
    public collectionBackgroundColors;
    public imageSet;
	public title: string = "";
	private previouslyFocusedElement: HTMLElement | null = null;
	private focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
	// @ngInject
	constructor(
		public imageService   : ImageService,
		public ModalService,
		public $element,
		public $timeout			: ng.ITimeoutService
	){}
	
	public $onInit = () => {
		// Store the element that had focus before the modal opened
		this.previouslyFocusedElement = document.activeElement as HTMLElement;
		// Set initial focus to the close button after render
		this.$timeout(() => {
			const modalEl = this.$element[0].querySelector('.modal');
			if (modalEl) {
				modalEl.removeAttribute('aria-hidden');
				const closeBtn = modalEl.querySelector('.close') as HTMLElement;
				if (closeBtn) {
					closeBtn.focus();
				}
			}
		});
	}

	public handleKeydown = (event: KeyboardEvent) => {
		if (event.key === 'Escape' || event.keyCode === 27) {
			event.preventDefault();
			this.close();
		}

		if (event.key === 'Tab' || event.keyCode === 9) {
			this.trapFocus(event);
		}
	}

	private trapFocus = (event: KeyboardEvent) => {
		const modalEl = this.$element[0].querySelector('.modal');
		if (!modalEl) return;

		const focusableElements = modalEl.querySelectorAll(this.focusableSelector);
		if (focusableElements.length === 0) return;

		const firstFocusable = focusableElements[0] as HTMLElement;
		const lastFocusable = focusableElements[focusableElements.length - 1] as HTMLElement;

		if (event.shiftKey) {
			if (document.activeElement === firstFocusable) {
				event.preventDefault();
				lastFocusable.focus();
			}
		} else {
			if (document.activeElement === lastFocusable) {
				event.preventDefault();
				firstFocusable.focus();
			}
		}
	}

	public save = () =>{
		
		this.isLoading = true;
		
		if( this.isLoading && this.title != "") {
			let imageSet: IDavis.IImageSet = {
				title: this.title,
				imageSetID: this.imageSet.imageSetID,
			};
			
			this.imageService.copyImageSet(imageSet).then(
				(response)=>{
					console.log('respy', response);
				},
				(reason) =>{
				  window.location.href = "/images?currentPage=1&tab=mycollections&imagesetid="+reason.data.imageSetID;
				}
			).finally(()=>{
				this.isLoading = false;
				this.close();
			})
		}
	}
	
	public close = () =>{
		this.ModalService.closeModals();

		// Restore focus to the previously focused element
		if (this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
			this.previouslyFocusedElement.focus();
		}
	}
}
    

class ImageCollectionCopyModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
		close:'=',
		collectionBackgroundColors: '=?',
		imageSet:'=?'
	};

	public controller = ImageCollectionCopyModalController;
	public controllerAs = 'imageCollectionCopyModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/image-collection-copy-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { ImageCollectionCopyModal };